var _ellipse, _g, _g2, _g3, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoSolutionSelected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 120,
    viewBox: "0 0 136 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.0427,
    cy: 59.9062,
    rx: 59.625,
    ry: 59.9062,
    fill: "url(#paint0_linear_3899_9990)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3899_9990)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.5417,
    y: 31.5,
    width: 45.1023,
    height: 56.7,
    rx: 7.8902,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.0349,
    y: 31.9931,
    width: 44.116,
    height: 55.7137,
    rx: 7.39706,
    stroke: "#F8FAFC",
    strokeWidth: 0.986275,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.0928,
    y: 48.8496,
    width: 22,
    height: 22,
    rx: 11,
    fill: "#EEF2F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.0928,
    y: 48.8496,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "#F8FAFC",
    strokeWidth: 3.50903
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4262 62.516H70.7595V63.8493H65.4262V62.516ZM65.4262 59.8493H70.7595V61.1826H65.4262V59.8493ZM69.4262 53.1826H64.0929C63.3595 53.1826 62.7595 53.7826 62.7595 54.516V65.1826C62.7595 65.916 63.3529 66.516 64.0862 66.516H72.0929C72.8262 66.516 73.4262 65.916 73.4262 65.1826V57.1826L69.4262 53.1826ZM72.0929 65.1826H64.0929V54.516H68.7595V57.8493H72.0929V65.1826Z",
    fill: "#9AA4B2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3899_9990)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.47925,
    y: 50.0625,
    width: 33.1108,
    height: 41.625,
    rx: 5.79241,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.84127,
    y: 50.4245,
    width: 32.3867,
    height: 40.9009,
    rx: 5.43038,
    stroke: "#F8FAFC",
    strokeWidth: 0.724051,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.0347,
    y: 63.875,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#EEF2F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.0347,
    y: 63.875,
    width: 14,
    height: 14,
    rx: 7,
    stroke: "#F8FAFC",
    strokeWidth: 2.17215
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3899_9990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.368 67.208H18.7013C18.3347 67.208 18.038 67.508 18.038 67.8747L18.0347 72.1847C18.0347 72.4147 18.1513 72.618 18.328 72.738L21.0347 74.5413L23.738 72.738C23.9147 72.618 24.0313 72.4147 24.0313 72.1847L24.0347 67.8747C24.0347 67.508 23.7347 67.208 23.368 67.208ZM21.0347 73.7413L18.7013 72.188V67.8747H23.368V72.1847L21.0347 73.7413ZM20.3647 71.268L19.5047 70.4047L19.0347 70.8747L20.368 72.208L23.0347 69.5413L22.5613 69.068L20.3647 71.268Z",
    fill: "#9AA4B2"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3899_9990)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.4167,
    y: 50.0625,
    width: 33.1108,
    height: 41.625,
    rx: 5.79241,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.7788,
    y: 50.4245,
    width: 32.3867,
    height: 40.9009,
    rx: 5.43038,
    stroke: "#F8FAFC",
    strokeWidth: 0.724051,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.972,
    y: 63.875,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#EEF2F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.972,
    y: 63.875,
    width: 14,
    height: 14,
    rx: 7,
    stroke: "#F8FAFC",
    strokeWidth: 2.17215
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3899_9990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.972 67.875L111.305 69.875L112.639 70.6017V72.6017L114.972 73.875L117.305 72.6017V70.6017L117.972 70.2383V72.5417H118.639V69.875L114.972 67.875ZM117.245 69.875L114.972 71.115L112.699 69.875L114.972 68.635L117.245 69.875ZM116.639 72.205L114.972 73.115L113.305 72.205V70.965L114.972 71.875L116.639 70.965V72.205Z",
    fill: "#9AA4B2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.8101 43.9505C50.6991 47.5312 48.1787 52.5982 47.8034 58.037C47.4282 63.4759 49.2287 68.8411 52.8089 72.9525C58.7912 79.8213 68.7369 81.932 76.9976 78.0844C78.6529 77.3119 80.1973 76.3213 81.5898 75.139L81.8891 74.8865L101.87 93.7143C102.241 94.0586 102.733 94.2424 103.238 94.2255C103.744 94.2086 104.223 93.9925 104.57 93.6242C104.917 93.2559 105.104 92.7654 105.091 92.2596C105.077 91.7538 104.865 91.2738 104.499 90.9242L84.5208 72.101L84.7563 71.7865C87.8031 67.7245 89.2388 62.6785 88.7866 57.621C88.3345 52.5634 86.0264 47.8521 82.3073 44.395C78.5882 40.9379 73.7212 38.9795 68.6441 38.8974C63.567 38.8152 58.6392 40.615 54.8101 43.9499V43.9505ZM69.462 42.7701C73.6834 43.0616 77.6374 44.9424 80.5271 48.0335C83.4169 51.1245 85.0275 55.1961 85.0343 59.4276C85.0343 59.8183 85.0203 60.2103 84.9922 60.6036C84.8058 63.3503 83.9444 66.0086 82.4845 68.3426C81.0246 70.6767 79.0113 72.6145 76.6232 73.9841C74.235 75.3536 71.5457 76.1128 68.7939 76.1941C66.0421 76.2754 63.3127 75.6764 60.8478 74.4502C58.383 73.224 56.2588 71.4085 54.6636 69.1647C53.0685 66.9209 52.0516 64.3181 51.7033 61.5872C51.355 58.8563 51.686 56.0816 52.6669 53.5093C53.6478 50.9369 55.2483 48.6464 57.3265 46.8408C58.9801 45.3942 60.9039 44.2897 62.9869 43.591C65.0698 42.8923 67.2706 42.6133 69.462 42.7701Z",
    fill: "#004B87"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3899_9990",
    x: 40.6104,
    y: 27.0618,
    width: 54.965,
    height: 66.5629,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.493137
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.46569
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411538 0 0 0 0 0.55 0 0 0 0 0.688462 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3899_9990"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3899_9990",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3899_9990",
    x: 0.858993,
    y: 46.8043,
    width: 40.3513,
    height: 48.8655,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.362025
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.81013
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411538 0 0 0 0 0.55 0 0 0 0 0.688462 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3899_9990"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3899_9990",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3899_9990",
    x: 94.7965,
    y: 46.8043,
    width: 40.3513,
    height: 48.8655,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.362025
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.81013
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411538 0 0 0 0 0.55 0 0 0 0 0.688462 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3899_9990"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3899_9990",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3899_9990",
    x1: 68.0427,
    y1: 0,
    x2: 68.0427,
    y2: 119.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3899_9990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(17.0347 66.875)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3899_9990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(110.972 66.875)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoSolutionSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/NoSolutionSelected.8e78c882be27e0353e2174bfe9867c53.svg";